import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSortAsc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "funnel-39" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("defs", {}),
		/* @__PURE__ */ _jsx("g", {
			id: "Icons",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Artboard",
				transform: "translate(-281.000000, -621.000000)",
				fill: "#190026",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "funnel-39",
					transform: "translate(289.000000, 628.000000) scale(1, -1) translate(-289.000000, -628.000000) translate(281.000000, 621.000000)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M9,14 L7,14 C6.448,14 6,13.552 6,13 C6,12.448 6.448,12 7,12 L9,12 C9.552,12 10,12.448 10,13 C10,13.552 9.552,14 9,14 Z",
							id: "Shape"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M11,10 L5,10 C4.448,10 4,9.552 4,9 C4,8.448 4.448,8 5,8 L11,8 C11.552,8 12,8.448 12,9 C12,9.552 11.552,10 11,10 Z",
							id: "Shape"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M13,6 L3,6 C2.448,6 2,5.552 2,5 C2,4.448 2.448,4 3,4 L13,4 C13.552,4 14,4.448 14,5 C14,5.552 13.552,6 13,6 Z",
							id: "Shape"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M15,2 L1,2 C0.448,2 0,1.552 0,1 C0,0.448 0.448,0 1,0 L15,0 C15.552,0 16,0.448 16,1 C16,1.552 15.552,2 15,2 Z",
							id: "Shape"
						})
					]
				})
			})
		})
	]
});
export default SvgIconSortAsc;
